import { render, staticRenderFns } from "./RegisterFooter.vue?vue&type=template&id=08198913&scoped=true"
import script from "./RegisterFooter.vue?vue&type=script&lang=js"
export * from "./RegisterFooter.vue?vue&type=script&lang=js"
import style0 from "./RegisterFooter.vue?vue&type=style&index=0&id=08198913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08198913",
  null
  
)

export default component.exports